import { StateToken } from '@ngxs/store';
import type { AppStateModel } from './app-state.model';

export const APP_STATE_TOKEN = new StateToken<AppStateModel>('app');
